module.exports = __webpack_public_path__ + "static/img/data.6f20c2ee.png";